export const stages = [
  {
    id: 1,
    mois: 'Juin 2025',
    titre: 'Chandra Yoga et corps conscient',
    dates: '6 au 8 Juin 2025',
    lieu: "L'Orne",
    duree: '3 jours / 2 nuits 310€ (270€ jusquau 15 Mars)',
  },
  // {
  //   id: 2,
  //   mois: 'Août 2025',
  //   titre: 'Thrulkhors de santé et corps conscient',
  //   dates: '22 au 24 Août',
  //   lieu: "L'Orne",
  //   duree: '3 jours / 2 nuits 310€ (270€ jusquau 15 Mai)',
  // },
];
